var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.naturaV3DarkColorTokens = void 0;
var natds_themes_1 = __importDefault(require("@naturacosmeticos/natds-themes"));
var color = natds_themes_1.default.natura_v3.dark.color;
exports.naturaV3DarkColorTokens = {
    colorPrimary: color.primary,
    colorOnPrimary: color.onPrimary,
    colorPrimaryLight: color.primaryLight,
    colorOnPrimaryLight: color.onPrimaryLight,
    colorPrimaryDark: color.primaryDark,
    colorOnPrimaryDark: color.onPrimaryDark,
    colorSecondary: color.secondary,
    colorOnSecondary: color.onSecondary,
    colorSecondaryLight: color.secondaryLight,
    colorOnSecondaryLight: color.onSecondaryLight,
    colorSecondaryDark: color.secondaryDark,
    colorOnSecondaryDark: color.onSecondaryDark,
    colorBackground: color.background,
    colorOnBackground: color.onBackground,
    colorSurface: color.surface,
    colorOnSurface: color.onSurface,
    colorHighlight: color.highlight,
    colorHighEmphasis: color.highEmphasis,
    colorMediumEmphasis: color.mediumEmphasis,
    colorLowEmphasis: color.lowEmphasis,
    colorLink: color.link,
    colorOnLink: color.onLink,
    colorSuccess: color.success,
    colorOnSuccess: color.onSuccess,
    colorWarning: color.warning,
    colorOnWarning: color.onWarning,
    colorAlert: color.alert,
    colorOnAlert: color.onAlert
};
exports.default = exports.naturaV3DarkColorTokens;
//# sourceMappingURL=natura_v3-dark.js.map